import gtag_event from '../page-template/page-builder/gtag-init';

const defaultScreenHeight = window.innerHeight;

const KEY_NAME      = 'CHAT_NAME';
const KEY_PHONE     = 'CHAT_PHONE';
const KEY_QUESTION  = 'CHAT_QUESTION';
const MAX_WIDTH_MEDIA = 600; // readjust this with media query mobile css @ _header.scss

class NNPseudoChatBox {

    constructor($, chatBoxConfig) {
        this.chatContainerId    = chatBoxConfig.CSS.IDs.container;
        this.contentContainer   = $(`#${this.chatContainerId} .pseudo-chat-content`);
        this.headerContainer    = $(`#${this.chatContainerId} .pseudo-chat-header`);
        this.footerContainer    = $(`#${this.chatContainerId} .pseudo-chat-footer`);
        this.delay              = $(`#${this.chatContainerId}`).data('delay') ? $(`#${this.chatContainerId}`).data('delay') : chatBoxConfig.application.autoShowDelay;
        this.projectName        = $(`#${this.chatContainerId}`).data('projectName') ? $(`#${this.chatContainerId}`).data('projectName') : '<no project>';
        this.questions          = $(`#${this.chatContainerId}`).data('questions') ? $(`#${this.chatContainerId}`).data('questions') : [];
        this.pseudoCodeMode     = chatBoxConfig.application.pseudoCodeMode;
        this.botDelay           = chatBoxConfig.application.botDelay;
        this.formAction         = $(`#${this.chatContainerId}`).data('formAction') ? $(`#${this.chatContainerId}`).data('formAction') : '';
        this.formContainer      = $(`#${this.chatContainerId} ~ form.whatsapp-form`);
        this.isConsideredMobile = window.matchMedia(`(max-width: ${MAX_WIDTH_MEDIA-1}px)`).matches;
        this.version            = $(`#${this.chatContainerId}`).hasClass('chat-v2') ? 2 : 1;
        this.position           = $(`#${this.chatContainerId}`).data('position') ? $(`#${this.chatContainerId}`).data('position') : 'fab';
    }

    baseBotChatTempl(message, divClass) {
        return `<div class="${this.pseudoCodeMode ? 'pseudo-chat-template' : ''} char-bot ${divClass ? divClass : ''}">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="16" fill="#cccccc"/>
                <path d="M23.2164 12.363H24.1818C24.664 12.363 25.1265 12.5545 25.4675 12.8955C25.8084 13.2365 26 13.699 26 14.1812V17.8178C26 18.3 25.8084 18.7625 25.4675 19.1035C25.1265 19.4445 24.664 19.6361 24.1818 19.6361H23.2164C22.9947 21.3937 22.1393 23.01 20.8107 24.1817C19.482 25.3534 17.7715 26 16 26V24.1817C17.4466 24.1817 18.834 23.607 19.8569 22.5841C20.8799 21.5611 21.4545 20.1736 21.4545 18.7269V13.2721C21.4545 11.8254 20.8799 10.4379 19.8569 9.41497C18.834 8.39199 17.4466 7.81729 16 7.81729C14.5534 7.81729 13.166 8.39199 12.1431 9.41497C11.1201 10.4379 10.5455 11.8254 10.5455 13.2721V19.6361H7.81818C7.33597 19.6361 6.87351 19.4445 6.53253 19.1035C6.19156 18.7625 6 18.3 6 17.8178V14.1812C6 13.699 6.19156 13.2365 6.53253 12.8955C6.87351 12.5545 7.33597 12.363 7.81818 12.363H8.78364C9.00548 10.6055 9.86098 8.98942 11.1896 7.81791C12.5182 6.6464 14.2287 6 16 6C17.7713 6 19.4818 6.6464 20.8104 7.81791C22.139 8.98942 22.9945 10.6055 23.2164 12.363ZM7.81818 14.1812V17.8178H8.72727V14.1812H7.81818ZM23.2727 14.1812V17.8178H24.1818V14.1812H23.2727ZM12.1455 19.4406L13.1091 17.8987C13.9755 18.4415 14.9776 18.7286 16 18.7269C17.0224 18.7286 18.0245 18.4415 18.8909 17.8987L19.8545 19.4406C18.6993 20.1644 17.3632 20.5473 16 20.5452C14.6368 20.5473 13.3007 20.1644 12.1455 19.4406Z" fill="white"/>
            </svg>
            <div class="message">${message}</div>
        </div>`;
    }

    baseVisitorChatTempl(message) {
        return `<div class="${this.pseudoCodeMode ? 'pseudo-chat-template' : ''} char-visitor">
        <div class="message">
            ${message}
            <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0091 2.84773L8.48372 16.1463L0.868652 8.53121L3.13139 6.26847L8.31633 11.4534L17.5909 0.751953L20.0091 2.84773Z" fill="#01C851"/>
            </svg>
        </div>
        </div>`
    }

    loadingBotChatTempl() {
        return this.baseBotChatTempl('…', 'pseudo-loading');
    }

    inputBotChatTempl(message, inputPlaceholder, key) {
        return this.baseBotChatTempl(`${message}
        <div class="pseudo-chat-input-box input-${key}" id="input-${key}">
            <div class="pseudo-chat-input-wrapper">
                <input type="text" placeholder="${inputPlaceholder}" id="field-${key}">
                <label for="field-${key}">
                    <span class="pseudo-chat-input-error"></span>
                </label>
            </div>
            <button data-key="${key}">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="48" rx="8" fill="#cccccc"/>
                    <path d="M11.2002 35.2628C11.2002 35.9861 11.9444 36.4702 12.6056 36.177L40.0002 24.0288L12.6071 11.8269C11.9457 11.5323 11.2002 12.0163 11.2002 12.7404V20.5507C11.2002 21.5947 12.0032 22.4631 13.0441 22.5446L32.0002 24.0288L13.0495 25.4605C12.0064 25.5393 11.2002 26.4087 11.2002 27.4548V35.2628Z" fill="white"/>
                </svg>
            </button>
        </div>`, 'chat-input');
    }

    radioBotChatTempl(message, items, id) {
        const pseudoChat = this;
        const itemsHtml = items.map(function (item) {
            const questionSlug = pseudoChat.convertToSlug(item.question);
            return `<div class="pseudo-chat-option-item">
            <input type="radio" name="questions" id="${questionSlug}" value="${item.question}">
            <label for="${questionSlug}" >${item.question}</label>
        </div>`;
        }).join('');
        const templ = `<div class="pseudo-chat-option-message">${message}</div>${itemsHtml}
        <button disabled>Kirim
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill="#cccccc"/>
                <path d="M11.2002 35.2628C11.2002 35.9861 11.9444 36.4702 12.6056 36.177L40.0002 24.0288L12.6071 11.8269C11.9457 11.5323 11.2002 12.0163 11.2002 12.7404V20.5507C11.2002 21.5947 12.0032 22.4631 13.0441 22.5446L32.0002 24.0288L13.0495 25.4605C12.0064 25.5393 11.2002 26.4087 11.2002 27.4548V35.2628Z" fill="white"/>
            </svg>
        </button>`;
        return this.baseBotChatTempl(templ, `pseudo-chat-options options-${id ? id : ''}`);
    }

    radioBotScreenTempl(message, items, id, withOthers) {
        const pseudoChat = this;
        const tempItems = [...items];
        if (withOthers) {
            tempItems.push({question: 'Pertanyaan Lainnya'});
        }
        const itemsHtml = tempItems.map(function (item) {
            const questionSlug = pseudoChat.convertToSlug(item.question);
            return `<div class="pseudo-chat-option-item">
            <input type="radio" name="questions" id="${questionSlug}" value="${item.question}">
            <label for="${questionSlug}" >${item.question}</label>
        </div>`;
        }).join('');
        const templ = `<div class="pseudo-chat-option-message">${message}</div>${itemsHtml}`;
        return `<div class="pseudo-chat-template pseudo-chat-options options-${id ? id : ''}">
        ${templ}
        <div class="pseudo-chat-textarea-box input-other" id="input-other">
            <div class="pseudo-chat-input-wrapper">
                <textarea placeholder="Tulis pesan"></textarea>
                <label for="field-other">
                    <span class="pseudo-chat-input-error"></span>
                </label>
            </div>
        </div>
        </div>`;
    }

    /**
     * prepare for input field name (v1)
     */
    prepareInputName() {
        this.contentContainer
            .append(this.baseBotChatTempl(`Halo, selamat datang. Sales konsultan ${this.projectName} akan membantu Anda`))
            .append(this.loadingBotChatTempl());
        sleep(this.botDelay).then(() => {
            $('.pseudo-loading', this.contentContainer)
                .replaceWith(this.inputBotChatTempl('Untuk memulai percakapan, silakan masukkan <strong>Nama Anda</strong>', 'Nama Anda', KEY_NAME));
            this.scrollToBottom();
            $(`.input-${KEY_NAME}>button`).off('click').on('click', () => {
                const value = $(`.input-${KEY_NAME} input`).val();
                // Validate input (empty)
                if (!value || (value && value.trim().length <= 3)) {
                    const error = 'Silakan isi Nama';
                    $(`.input-${KEY_NAME}`).addClass('has-error');
                    $(`.input-${KEY_NAME} .pseudo-chat-input-error`).text(error);
                    return;
                } else if (/^\d+$/.test(value)) {
                    const error = 'Silakan isi Nama';
                    $(`.input-${KEY_NAME}`).addClass('has-error');
                    $(`.input-${KEY_NAME} .pseudo-chat-input-error`).text(error);
                    return;
                } else {
                    if ($(`.input-${KEY_NAME}`).hasClass('has-error')) {
                        $(`.input-${KEY_NAME}`).removeClass('has-error');
                        $(`.input-${KEY_NAME} .pseudo-chat-input-error`).empty();
                    }
                }
                localStorage.setItem(KEY_NAME, value);
                this.contentContainer.append(this.baseVisitorChatTempl(value));
                this.scrollToBottom();
                $(`.input-${KEY_NAME} input`).prop('disabled', true);
                $(`.input-${KEY_NAME}>button`).prop('disabled', true).off('click');
                $(`#input-${KEY_NAME}`).remove();
                this.prepareInputPhone();
            });
        });
    }

    /**
     * prepare for displaying input result for field name (v1)
     */
    displayInputName() {
        this.contentContainer
            .append(this.baseBotChatTempl(`Halo, selamat datang. Sales konsultan ${this.projectName} akan membantu Anda`))
            .append(this.inputBotChatTempl('Untuk memulai percakapan, silakan masukkan <strong>Nama Anda</strong>', 'Nama Anda', KEY_NAME));
        const value = localStorage.getItem(KEY_NAME);
        $(`.input-${KEY_NAME}>input`).val(value).prop('disabled', true);
        $(`.input-${KEY_NAME}>button`).prop('disabled', true);
        $(`#input-${KEY_NAME}`).remove();
        this.contentContainer.append(this.baseVisitorChatTempl(value));
    }

    /**
     * prepare for input field phone (v1)
     */
    prepareInputPhone() {
        this.contentContainer
                .append(this.loadingBotChatTempl());
        sleep(this.botDelay).then(() => {
            $('.pseudo-loading', this.contentContainer)
                .replaceWith(this.baseBotChatTempl('Kami akan menjawab pertanyaan Anda melalui WhatsApp') + this.loadingBotChatTempl());
            this.scrollToBottom();
        }).then(() => {
            sleep(this.botDelay).then(() => {
                $('.pseudo-loading', this.contentContainer)
                    .replaceWith(this.inputBotChatTempl('Boleh sebutkan <strong>nomor WhatsApp</strong> Anda yang dapat kami hubungi...', 'No. WhatsApp', KEY_PHONE));
                this.scrollToBottom();
                $(`.input-${KEY_PHONE}>button`).off('click').on('click', () => {
                    let value = $(`.input-${KEY_PHONE} input`).val();
                    // form processing reflects/taken from whatsapp_submission.js
                    // clean number
                    value = value.replace(/\D/g,'');
                    if (value != '') {
                        if (value.charAt(0) == 0) {
                            value = `62${value.substr(1)}`;
                        }
                    }
                    // Validate Input (empty, phone format min 10)
                    if (!value || (value && value.trim().length == 0)) {
                        const error = 'Silakan isi No. Whatsapp';
                        $(`.input-${KEY_PHONE}`).addClass('has-error');
                        $(`.input-${KEY_PHONE} .pseudo-chat-input-error`).text(error);
                        return;
                    } else if (value.charAt(0) == 0) {
                        const error = 'Mohon gunakan kode negara (Contoh: 628123456789)';
                        $(`.input-${KEY_PHONE}`).addClass('has-error');
                        $(`.input-${KEY_PHONE} .pseudo-chat-input-error`).text(error);
                        return;
                    } else if (value.length < 11 || value.length > 14) {
                        const error = 'Format tidak sesuai';
                        // 10-13 karakter menggunakan 0 di awal
                        // let error = 'Panjang diantara 10 - 13 karakter';
                        $(`.input-${KEY_PHONE}`).addClass('has-error');
                        $(`.input-${KEY_PHONE} .pseudo-chat-input-error`).text(error);
                        return;
                    } else if (value.substring(0, 4) == '6262') {
                        const error = 'Silakan isi No. Whatsapp dengan benar';
                        $(`.input-${KEY_PHONE}`).addClass('has-error');
                        $(`.input-${KEY_PHONE} .pseudo-chat-input-error`).text(error);

                        return;
                    } else {
                        if ($(`.input-${KEY_PHONE}`).hasClass('has-error')) {
                            $(`.input-${KEY_PHONE}`).removeClass('has-error');
                            $(`.input-${KEY_PHONE} .pseudo-chat-input-error`).empty();
                        }
                    }
                    localStorage.setItem(KEY_PHONE, value);
                    this.contentContainer.append(this.baseVisitorChatTempl(value));
                    this.scrollToBottom();
                    $(`.input-${KEY_PHONE} input`).prop('disabled', true);
                    $(`.input-${KEY_PHONE}>button`).prop('disabled', true).off('click');
                    $(`#input-${KEY_PHONE}`).remove();
                    this.prepareInputQuestions();
                });
            });
        });
    }

    /**
     * prepare for displaying input result for field phone (v1)
     */
    displayInputPhone() {
        this.contentContainer
            .append(this.baseBotChatTempl('Kami akan menjawab pertanyaan Anda melalui WhatsApp'))
            .append(this.inputBotChatTempl('Boleh sebutkan <strong>nomor WhatsApp</strong> Anda yang dapat kami hubungi...', 'No. WhatsApp', KEY_PHONE));
        const value = localStorage.getItem(KEY_PHONE);
        $(`.input-${KEY_PHONE}>input`).val(value).prop('disabled', true);
        $(`.input-${KEY_PHONE}>button`).prop('disabled', true);
        $(`#input-${KEY_PHONE}`).remove();
        this.contentContainer.append(this.baseVisitorChatTempl(value));
    }

    /**
     * prepare for displaying radio options for questions (v1)
     */
    prepareInputQuestions() {
        const pseudoChat = this;
        this.contentContainer
                .append(this.loadingBotChatTempl());
        sleep(this.botDelay).then(() => {
            $('.pseudo-loading', this.contentContainer)
                .replaceWith(this.baseBotChatTempl('Silakan ajukan pertanyaan Anda') + this.loadingBotChatTempl());
            this.scrollToBottom();
            sleep(this.botDelay).then(() => {
                $('.pseudo-loading', this.contentContainer)
                    .replaceWith(this.baseBotChatTempl('Anda juga dapat memilih untuk mengajukan pertanyaan lainnya') + this.loadingBotChatTempl());
                this.scrollToBottom();
                $('.pseudo-loading', this.contentContainer)
                    .replaceWith(this.radioBotChatTempl('Pilih pertanyaan', this.questions));
                $('.pseudo-chat-options .pseudo-chat-option-item input[type=radio][name=questions]').off('change').on('change', () => {
                    let hasChecked = false;
                    $('.pseudo-chat-options .pseudo-chat-option-item input[type=radio][name=questions]').each(function() {
                        if ($(this).is(':checked')) {
                            hasChecked = true;
                        }
                    });
                    if (hasChecked) {
                        $('.pseudo-chat-options button')
                            .prop('disabled', false);
                    }
                });
                this.contentContainer.addClass('footer-visible');
                // textbox height auto-resize based on input
                $('.pseudo-chat-footer .pseudo-chat-textarea-box .pseudo-chat-input-wrapper textarea').each(function () {
                    this.setAttribute('style', `height:${this.scrollHeight}px;overflow-y:hidden;`);
                }).off('input').on('input', function () {
                    this.style.height   = 'auto';
                    this.style.height   = `${this.scrollHeight}px`;
                    const footerHeight  = $('.pseudo-chat-footer').height();
                    let contentHeight   = 518;

                    if (pseudoChat.isConsideredMobile) {
                        const selector  =  $(`#${pseudoChat.chatContainerId}`);
                        contentHeight   = selector.height() - 122; // minus header
                    }
                    pseudoChat.contentContainer[0].style.height = (contentHeight - footerHeight) + 'px';
                    // if more than 5 character
                    const button = $('.pseudo-chat-footer .pseudo-chat-textarea-box button');
                    if ($(this).val().length > 5) {
                        // enable button
                        button.prop('disabled', false);
                    } else {
                        button.prop('disabled', true);
                    }
                });

                // Handle submit from Radio Options
                $('.pseudo-chat-options button').off('click').on('click', () => {
                    let value;
                    $('.pseudo-chat-options .pseudo-chat-option-item input[type=radio][name=questions]').each(function() {
                        if ($(this).is(':checked')) {
                            value = $(this).val();
                        }
                    });
                    localStorage.setItem(KEY_QUESTION, value);
                    $('.pseudo-chat-options button').prop('disabled', true);

                    $('.pseudo-chat-options').remove();
                    this.contentContainer.removeClass('footer-visible');
                    this.contentContainer.append(this.baseVisitorChatTempl(value));
                    this.contentContainer.append(this.baseBotChatTempl('Terimakasih, pertanyaan Anda telah terkirim. Anda akan segera diarahkan ke WhatsApp kami'))
                        .append(this.loadingBotChatTempl());
                    sleep(this.botDelay).then(() => {
                        $('.pseudo-loading', this.contentContainer)
                            .replaceWith(this.baseBotChatTempl('Mohon tunggu beberapa saat...'));
                        this.scrollToBottom();
                    });

                    gtag_event('Send question clicked', value);
                    // simulates leads form sending
                    gtag_event('Leads form button clicked', 'live_chat');
                    // SUBMIT TO SERVER
                    this.submitData();
                });
                // Handle submit from Other Questions (textarea)
                $('.pseudo-chat-footer .pseudo-chat-textarea-box button').off('click').on('click', () => {
                    const value = $('.pseudo-chat-footer .pseudo-chat-input-wrapper textarea').val();
                    localStorage.setItem(KEY_QUESTION, value);
                    $(this).prop('disabled', true);

                    $('.pseudo-chat-options').remove();
                    this.contentContainer.removeClass('footer-visible');
                    this.contentContainer.append(this.baseVisitorChatTempl(value));
                    this.contentContainer.append(this.baseBotChatTempl('Terimakasih, pertanyaan Anda telah terkirim. Anda akan segera diarahkan ke WhatsApp kami'))
                        .append(this.loadingBotChatTempl());
                    sleep(this.botDelay).then(() => {
                        $('.pseudo-loading', this.contentContainer)
                            .replaceWith(this.baseBotChatTempl('Mohon tunggu beberapa saat...'));
                        this.scrollToBottom();
                    });

                    gtag_event('Send question clicked', value);
                    // simulates leads form sending
                    gtag_event('Leads form button clicked', 'live_chat');
                    // SUBMIT TO SERVER
                    this.submitData();
                });
            });
        });
    }

    /**
     * prepare for displaying radio options for questions (v2)
     */
    prepareInputQuestionsV2() {
        const pseudoChat = this;
        this.contentContainer.css('background', '#fff');
        this.contentContainer.addClass('footer-visible');
        this.footerContainer.css('background', '#fff');
        this.footerContainer.html('<button class="pseudo-screen-continue" disabled>Lanjutkan</button>');
        $('span', this.headerContainer).html(`Selamat datang di <div class="project-name">${this.projectName}</div>`).show(0);
        $('p', this.headerContainer).html('Anda dapat memilih atau mengajukan pertanyaan lainnya, sales konsultan kami akan segera membantu Anda.').show(0);

        this.contentContainer.append(pseudoChat.radioBotScreenTempl('', this.questions, 'screen-options', true));
        $('.pseudo-chat-textarea-box.input-other').addClass('d-none');
        let value;
        $('.pseudo-chat-options .pseudo-chat-option-item input[type=radio][name=questions]').off('change').on('change', () => {
            let hasChecked = false;
            $('.pseudo-chat-options .pseudo-chat-option-item input[type=radio][name=questions]').each(function() {
                if ($(this).is(':checked')) {
                    hasChecked = true;
                    value = $(this).val();
                }
            });

            if (hasChecked) {
                $('.pseudo-chat-options button')
                    .prop('disabled', false);
                // hide header
                pseudoChat.headerContainer.addClass('paragraph-hidden');
                sleep(300).then(() => {
                    $('p', pseudoChat.headerContainer).addClass('d-none');
                });
                // this.headerContainer.height(122);
                pseudoChat.headerContainer.css('height', 'auto');
                const footerHeight  = pseudoChat.footerContainer.height();
                let contentHeight   = 518;
                if (pseudoChat.isConsideredMobile) {
                    // const selector  =  $(`#${pseudoChat.chatContainerId}`);
                    // contentHeight   = selector.height() - 122; // minus header
                    // jQuery('.pseudo-chat-content').height(visualViewport.height - jQuery('.pseudo-chat-header').height() - jQuery('.pseudo-chat-footer').height() - 32 - 32 + 'px')
                    // contentHeight   = selector.height() - pseudoChat.headerContainer.height(); // minus dynamic header
                    contentHeight = visualViewport.height - jQuery('.pseudo-chat-header').height();
                }
                pseudoChat.contentContainer[0].style.height = `${contentHeight - footerHeight - 32}px`;
                if (value == 'Pertanyaan Lainnya') {
                    const button = $('.pseudo-chat-footer button');
                    $('.pseudo-chat-textarea-box.input-other').removeClass('d-none');
                    $('.pseudo-chat-textarea-box.input-other textarea').val();
                    $('.pseudo-chat-textarea-box.input-other textarea').each(function () {
                        this.setAttribute('style', `height:${this.scrollHeight}px;overflow-y:hidden;`);
                    }).off('input').on('input', function () {
                        this.style.height   = 'auto';
                        this.style.height   = `${this.scrollHeight}px`;

                        // if more than 5 character
                        if ($(this).val().length > 5) {
                            localStorage.setItem(`${KEY_QUESTION}_tmp`, $(this).val());
                            // enable button
                            button.prop('disabled', false);
                        } else {
                            button.prop('disabled', true);
                        }
                    });
                    button.prop('disabled', true);
                } else {
                    $('.pseudo-chat-textarea-box.input-other').addClass('d-none');
                    $('button', this.footerContainer).prop('disabled', false);
                    localStorage.setItem(`${KEY_QUESTION}_tmp`, value);
                }
            } else {
                pseudoChat.headerContainer.removeClass('paragraph-hidden');
            }
        });

        $('button.pseudo-screen-continue', this.footerContainer).off('click').on('click', function() {
            // get question tmp value
            const value = localStorage.getItem(`${KEY_QUESTION}_tmp`);
            localStorage.setItem(KEY_QUESTION, value);
            localStorage.removeItem(`${KEY_QUESTION}_tmp`);

            pseudoChat.prepareInputInfoV2();
        });
    }

    prepareInputInfoV2() {
        const pseudoChat = this;
        this.clearContent();
        $('span', this.headerContainer).hide(0);
        $('p', this.headerContainer).html('Silakan isi data Anda terlebih dahulu supaya untuk kami dapat lebih mudah membantu Anda').removeClass('d-none');
        this.headerContainer.removeClass('paragraph-hidden');
        this.contentContainer.append(`
        <div class="pseudo-screen pseudo-screen-info">
            <div class="pseudo-screen-input-wrapper">
                <div class="pseudo-screen-input-label">Nama</div>
                <input type="text" placeholder="Tulis nama lengkap" id="field-CHAT_NAME">
                <label for="field-CHAT_NAME">
                    <span class="pseudo-chat-input-error"></span>
                </label>
            </div>
            <div class="pseudo-screen-input-wrapper">
                <div class="pseudo-screen-input-label">No. WhatsApp</div>
                <input type="text" placeholder="No. WhatsApp" id="field-CHAT_PHONE">
                <label for="field-CHAT_PHONE">
                    <span class="pseudo-chat-input-error"></span>
                </label>
            </div>
        </div>
        `);
        this.footerContainer.html(`
        <button class="pseudo-screen-send" disabled>
        Kirim
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="8" fill="#cccccc"/>
            <path d="M11.2002 35.2628C11.2002 35.9861 11.9444 36.4702 12.6056 36.177L40.0002 24.0288L12.6071 11.8269C11.9457 11.5323 11.2002 12.0163 11.2002 12.7404V20.5507C11.2002 21.5947 12.0032 22.4631 13.0441 22.5446L32.0002 24.0288L13.0495 25.4605C12.0064 25.5393 11.2002 26.4087 11.2002 27.4548V35.2628Z" fill="white"/>
        </svg>
        </button>
        `);

        $('#field-CHAT_NAME, #field-CHAT_PHONE').off('keyup').on('keyup', function() {
            const nameValue = $('#field-CHAT_NAME').val();
            const phoneValue = $('#field-CHAT_PHONE').val();
            const nameError = $('label[for=field-CHAT_NAME] .pseudo-chat-input-error');
            const phoneError = $('label[for=field-CHAT_PHONE] .pseudo-chat-input-error');

            let hasError = false;
            // Validate input Name (empty)
            if (!nameValue || (nameValue && nameValue.trim().length <= 3)) {
                const error = 'Silakan isi Nama';
                nameError.text(error);
                hasError = true;
            } else if (/^\d+$/.test(nameValue)) {
                const error = 'Silakan isi Nama';
                nameError.text(error);
                hasError = true;
            } else {
                nameError.empty();
            }

            let phoneVal = phoneValue.replace(/\D/g,'');

            if (phoneVal != '') {
                if (phoneVal.charAt(0) == 0) {
                    phoneVal = `62${phoneVal.substr(1)}`;
                }
            }
            // Validate Input Phone (empty, phone format min 10)
            if (!phoneVal || (phoneVal && phoneVal.trim().length == 0)) {
                const error = 'Silakan isi No. Whatsapp';
                phoneError.text(error);
                hasError = true;
            } else if (phoneVal.charAt(0) == 0) {
                const error = 'Mohon gunakan kode negara (Contoh: 628123456789)';
                phoneError.text(error);
                hasError = true;
            } else if (phoneVal.length < 11 || phoneVal.length > 14) {
                const error = 'Format tidak sesuai';
                // 10-13 karakter menggunakan 0 di awal
                // let error = 'Panjang diantara 10 - 13 karakter';
                phoneError.text(error);
                hasError = true;
            } else if (phoneVal.substring(0, 4) == '6262') {
                const error = 'Silakan isi No. Whatsapp dengan benar';
                phoneError.text(error);
                hasError = true;
            } else {
                phoneError.empty();
            }

            if (!hasError) {
                $('button.pseudo-screen-send').prop('disabled', false);
            } else {
                $('button.pseudo-screen-send').prop('disabled', true);
            }
        });

        $('button.pseudo-screen-send', this.footerContainer).off('click').on('click', function() {
            const nameValue = $('#field-CHAT_NAME').val();
            const phoneValue = $('#field-CHAT_PHONE').val();
            const nameError = $('label[for=field-CHAT_NAME] .pseudo-chat-input-error');
            const phoneError = $('label[for=field-CHAT_PHONE] .pseudo-chat-input-error');
            const question = localStorage.getItem(KEY_QUESTION);

            gtag_event('Send question clicked', question);

            let hasError = false;
            // Validate input Name (empty)
            if (!nameValue || (nameValue && nameValue.trim().length <= 3)) {
                const error = 'Silakan isi Nama';
                nameError.text(error);
                hasError = true;
            } else if (/^\d+$/.test(nameValue)) {
                const error = 'Silakan isi Nama';
                nameError.text(error);
                hasError = true;
            } else {
                nameError.empty();
            }

            let phoneVal = phoneValue.replace(/\D/g,'');

            if (phoneVal != '') {
                if (phoneVal.charAt(0) == 0) {
                    phoneVal = `62${phoneVal.substr(1)}`;
                }
            }
            // Validate Input Phone (empty, phone format min 10)
            if (!phoneVal || (phoneVal && phoneVal.trim().length == 0)) {
                const error = 'Silakan isi No. Whatsapp';
                phoneError.text(error);
                hasError = true;
            } else if (phoneVal.charAt(0) == 0) {
                const error = 'Mohon gunakan kode negara (Contoh: 628123456789)';
                phoneError.text(error);
                hasError = true;
            } else if (phoneVal.length < 11 || phoneVal.length > 14) {
                const error = 'Format tidak sesuai';
                // 10-13 karakter menggunakan 0 di awal
                // let error = 'Panjang diantara 10 - 13 karakter';
                phoneError.text(error);
                hasError = true;
            } else if (phoneVal.substring(0, 4) == '6262') {
                const error = 'Silakan isi No. Whatsapp dengan benar';
                phoneError.text(error);
                hasError = true;
            } else {
                phoneError.empty();
            }

            if (hasError) {
                // simulates leads form sending
                gtag_event('Leads form button clicked', 'live_chat-not-validated');
                return;
            }

            // simulates leads form sending
            gtag_event('Leads form button clicked', 'live_chat-validated');

            localStorage.setItem(KEY_NAME, nameValue);
            localStorage.setItem(KEY_PHONE, phoneVal);

            $(this).prop('disabled', true);

            // SUBMIT TO SERVER
            pseudoChat.submitData();
        });
    }

    init() {
        // REMARK: hides wpadminbar for development only
        $('#wpadminbar').hide();
        const pseudoChat = this;
        $('.btn-chat-box').off('click').off('click').on('click', () => {
            const hidden = $(`#${pseudoChat.chatContainerId}`).hasClass('pseudo-chat-hidden');
            $(`#${pseudoChat.chatContainerId}`).toggleClass('pseudo-chat-hidden', !hidden);
            if (hidden) {
                pseudoChat.show();
                if (pseudoChat.isConsideredMobile) {
                    $('body').css('overflow', 'hidden');
                }
                gtag_event('Chat button clicked', pseudoChat.position);
            } else {
                if (pseudoChat.isConsideredMobile) {
                    $('body').css('overflow', 'auto');
                }
            }
        });

        $(`#${pseudoChat.chatContainerId} .pseudo-chat-header .pseudo-chat-close`).off('click').on('click', () => {
            $(`#${pseudoChat.chatContainerId}`).addClass('pseudo-chat-hidden');
            if (pseudoChat.isConsideredMobile) {
                $('body').css('overflow', 'auto');
            }
        });

        if (pseudoChat.delay > 0) {
            setTimeout(() => {
                if ($(`#${pseudoChat.chatContainerId}`).hasClass('pseudo-chat-hidden')) {
                    $(`#${pseudoChat.chatContainerId}`).removeClass('pseudo-chat-hidden');
                    pseudoChat.show();
                    if (pseudoChat.isConsideredMobile) {
                        $('body').css('overflow', 'hidden');
                    }
                }
            }, pseudoChat.delay * 1000);
        }
    }

    show() {
        const NAME      = localStorage.getItem(KEY_NAME);
        const PHONE     = localStorage.getItem(KEY_PHONE);
        const QUESTION  = localStorage.getItem(KEY_QUESTION);
        const pseudoChat = this;

        if (pseudoChat.version == 2) {
            this.clearContent();
            // header height
            pseudoChat.headerContainer.removeClass('paragraph-hidden');
            $('p', pseudoChat.headerContainer).removeClass('d-none');

            const p             = $(`#${pseudoChat.chatContainerId} .pseudo-chat-header p`);
            const pHeight       = p.height();
            this.headerContainer.height(122 + pHeight - 16);

            const footerHeight  = this.footerContainer.height();
            let contentHeight   = 518;

            if (pseudoChat.isConsideredMobile) {
                const selector  =  $(`#${pseudoChat.chatContainerId}`);
                // contentHeight   = selector.height() - 122; // minus header
                // contentHeight   = selector.height() - this.headerContainer.height(); // minus dynamic header
                //contentHeight = visualViewport.height - jQuery('.pseudo-chat-header').height();
                contentHeight = selector.height()/2.5;
                pseudoChat.contentContainer[0].style.height = `${contentHeight}px`;
            } else {
                // pseudoChat.contentContainer[0].style.height = `${contentHeight - footerHeight}px`;
                pseudoChat.contentContainer[0].style.height = `${contentHeight - footerHeight - 32}px`;
            }

            this.prepareInputQuestionsV2()
        } else {
            // assumed version 1
            if (NAME !== null) {
                if (PHONE !== null) {
                    if (QUESTION !== null) {
                        // show all, ready to submit
                        this.clearContent();
                        this.displayInputName();
                        this.displayInputPhone();
                        this.prepareInputQuestions();
                    } else {
                        // show NAME & PHONE, continue QUESTION
                        this.clearContent();
                        this.displayInputName();
                        this.displayInputPhone();
                        this.prepareInputQuestions();
                    }
                } else {
                    // show NAME, continue PHONE
                    this.clearContent();
                    this.displayInputName();
                    this.prepareInputPhone();
                }
            } else {
                // start from the beginning, continue NAME
                this.clearContent();
                this.prepareInputName();
            }
        }
    }

    submitData() {
        // prepare input data, take from local storage
        $('input[name=name]', this.formContainer).val(localStorage.getItem(KEY_NAME));
        $('input[name=whatsapp_number]', this.formContainer).val(localStorage.getItem(KEY_PHONE));
        const dataForm = this.formContainer.serialize() + '&current_url=' + $(location).attr('href');
        const pseudoChat = this;
        $.ajax({
            type: 'post',
            url: this.formAction,
            data: dataForm,
            beforeSend: function() {},
            success: function (data) {
                if (data.success) {
                    pseudoChat.processData(data);
                } else {
                    const errorMessage = data.data.message;
                    if (2 == pseudoChat.version) {
                        console.error(`Terjadi kesalahan: ${errorMessage}`)
                        console.error('Mohon maaf ada kesalahan. Silakan tutup livechat kemudian coba lagi.')
                    } else {
                        // assume version 1
                        pseudoChat.contentContainer
                            .append(pseudoChat.baseBotChatTempl(`Terjadi kesalahan: <strong style="color: #cc0000;">${errorMessage}</strong>`))
                            .append(pseudoChat.baseBotChatTempl('Mohon maaf ada kesalahan. Silakan tutup livechat kemudian coba lagi.'));
                        // alert('Mohon maaf ada kesalahan. Silakan refresh halaman kemudian coba lagi.');
                        pseudoChat.scrollToBottom();
                    }
                    pseudoChat.clearData();

                }
            },
            error: function (data) {
                alert('Mohon maaf ada kesalahan. Silakan refresh halaman kemudian coba lagi.');
                console.error('An error occurred.');
                console.error(data);
            },
        });
    }

    processData(data) {
        if (data == -1 || data == '') {
            alert('Mohon maaf ada kesalahan. Silakan refresh halaman kemudian coba lagi.');
            return;
        }

        // submit success
        if (data.success) {
            // send GA tracking
            gtag_event('Whatsapp Submission', 'live_chat');

            // reset form input, in 1 sec
            sleep(1000).then(() => {
                this.redirectWhatsapp();
            }).then(() => {
                this.clearData();
                // hide
                this.hide();
            });
        }
    }

    redirectWhatsapp() {
        const MICROSITE_SUPERLEADS_ID = $('#nndc-footer__superleads-id').val();
        const superleadsText = encodeURIComponent(` (ID: ${MICROSITE_SUPERLEADS_ID})`);
        const telesalesNumber = $('[name=telesales_number]', this.formContainer).val();
        const message       = localStorage.getItem(KEY_QUESTION) ? localStorage.getItem(KEY_QUESTION) : '';
        if (!message) {
            console.warn('message is empty, not redirecting');
        }
        location.href       = whatsapp_base_url()+`/send?text=${message}${superleadsText}&phone=${telesalesNumber}`;
    }

    clearData() {
        localStorage.removeItem(KEY_NAME);
        localStorage.removeItem(KEY_PHONE);
        localStorage.removeItem(KEY_QUESTION);
    }

    scrollToBottom() {
        this.contentContainer.animate({ scrollTop: this.contentContainer[0].scrollHeight }, 500);
    }

    clearContent() {
        this.contentContainer.html('');
    }

    hide() {
        $(`#${this.chatContainerId}`).removeClass('pseudo-chat-hidden');
    }

    convertToSlug(text) {
        return text.toLowerCase()
            .replace(/ /g, '-')
            .replace(/[^\w-]+/g, '');
    }
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function whatsapp_base_url() {
    if( is_mobile() ) {
      return 'https://api.whatsapp.com';
    }

    return 'https://web.whatsapp.com';
}

function is_mobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      return true;
    }else{
      return false;
    }
}

function adjustChatBoxHeight() {

    if(is_mobile()){
        let pcb = document.querySelector('#pcb-container');

        if(window.innerHeight < defaultScreenHeight) {
            pcb.classList.add('pseudo-chat-wrapper-full');
        }else{
            pcb.classList.remove('pseudo-chat-wrapper-full');
        }
    }
    
}

window.addEventListener('resize', () => {
    adjustChatBoxHeight();
});


jQuery(function () {
    // Pseudo Chat Box configuration
    const chatBoxConfig = {
        CSS: {
            IDs: {
                container: 'pcb-container',
            },
        },
        application: {
            autoShowDelay: 5, // in seconds, this is used if no value at `data-delay` attribute
            pseudoCodeMode: false,
            botDelay: 500, // in milliseconds
        },
    };
    const chatBox = new NNPseudoChatBox(jQuery, chatBoxConfig);
    chatBox.init();
})



// WEBPACK FOOTER //
// ./scripts/global/pseudochat.js